export function getLanguageFromPath(path = "") {
  if (!path) {
    return;
  }
  const matches = /\/([^/]+)/.exec(path);
  return matches?.[1];
}
